<template>
  <v-autocomplete
    v-model="selected"
    :items.sync="items"
    item-text="key"
    item-value="key"
    :label="label"
    :clearable="clearable"
    return-object
    hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {MapGroupModel} from "@/modules/redactor/models/map/MapGroupModel";

export default {
  name: "r-map-group-dropdown",

  props: {
    model: VueTypes.instanceOf(MapGroupModel),
    label: VueTypes.string.def("Map Group"),
    clearable: VueTypes.bool.def(false)
  },

  data() {
    return {
      items: [],
      selected: null
    };
  },

  watch: {
    model(newVal) {
      this.selected = newVal ?? MapGroupModel.getNone(this.items);
    },

    selected(newVal) {
      if (MapGroupModel.isNone(newVal)) {
        this.$emit("update:model", MapGroupModel.getNone(this.items));
      } else {
        this.$emit("update:model", newVal);
      }
    }
  },

  created() {
    this.items = RedactorUtils.getMapGroups();

    this.selected = this.model ?? MapGroupModel.getNone(this.items);
  },
}
</script>